module.exports = __webpack_public_path__ + "a8d489283a5b2f515959e67fbb4a25bf.svg";